module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/selling-medium-faefc9a86dbfa85edf5d791dd2763373.svg";